import { NgModule } from '@angular/core';

import { NavItemComponent } from './NavItem.component';

@NgModule({
  declarations: [NavItemComponent],
  exports: [NavItemComponent],
})
export class NavItemModule {}
